{
  "label": "utilisateur",
  "button": {
    "delete": "Supprimer l'utilisateur",
    "create": "Nouvel utilisateur",
    "activate": "Activer l'utilisateur",
    "deactivate": "Désactiver l'utilisateur",
    "disabled": {
      "unauthorized": "Droits insuffisants pour modifier cet utilisateur"
    }
  },
  "empty": "Aucun utilisateur n'a été trouvé",
  "confirmRemove": {
    "title": "Suppression d'un utilisateur",
    "description": "L'utilisateur sélectionné \"{userName} {userFirstname}\" sera supprimé"
  },
  "form": {
    "userIdentity": {
      "title": "Informations"
    },
    "userProfile": {
      "title": "Profil"
    },
    "userGroups": {
      "title": "Groupes",
      "selectAllLabel": "Sélectionner tous les groupes"
    },
    "tabs": {
      "information": "Informations",
      "delegations": "Délégations"
    },
    "delegations": {
      "selectOrganization": "Sélectionner l'organisation",
      "selectProfile": "Sélectionner le profil",
      "noProfile": "Aucun profil"
    }
  },
  "search": "Recherche par nom ou prénom",
  "userAccount": {
    "userInformations": {
      "title": "Informations utilisateur"
    },
    "password": {
      "title": "Mot de passe"
    },
    "language": {
      "title": "Langue",
      "activeDirectoryWarning": "La modification de la langue n'est pas possible lorsque l'active directory est activé."
    },
    "certificate": {
      "title": "Certificat"
    },
    "instructions": {
      "informations": "Mettez à jour vos informations personnelles ici.",
      "email": "Gérez votre adresse email.",
      "phone": "Ajoutez votre numéro de téléphone.",
      "password": "Mettez à jour votre mot de passe.",
      "language": "Choisissez la langue que vous voulez utiliser pour LX CONNECT."
    },
    "forms": {
      "cancel": "Annuler",
      "certificateEmpty": "Aucun certificat",
      "certificateStatusDateFormat": "DD/MM/YYYY",
      "currentPassword": "Vérification du mot de passe actuel",
      "edit": "Éditer",
      "email": "Email",
      "firstName": "Prénom",
      "generatedOn": "Généré le",
      "lastName": "Nom",
      "login": "Login",
      "newPassword": "Nouveau mot de passe",
      "organisationName": "Nom de l'organisation",
      "phoneNumber": "Numéro de téléphone",
      "profile": "Profil",
      "requestNewCertificate": "Demander un nouveau certificat",
      "sectors": "Secteurs",
      "validate": "Valider",
      "validFrom": "Valide du",
      "validTo": "Valide jusqu’au"
    }
  },
  "table": {
    "column": {
      "lastName": "Nom",
      "firstName": "Prénom",
      "profile": "Profil",
      "email": "Email",
      "groups": "Groupes",
      "status": "Statut"
    }
  },
  "status": {
    "active": "Actif",
    "inactive": "Inactif"
  },
  "firstNameRequiredError": "Le prénom est requis.",
  "lastNameRequiredError": "Le nom est requis.",
  "loginRequiredError": "Le login est requis.",
  "emailRequiredError": "L'email est requis.",
  "languageError": "La langue est requise.",
  "firstNameLengthError": "Longueur comprise entre 1 et 50 caractères",
  "firstNameFormatError": "Caractères spéciaux autorisés sauf en début ou fin --> [ -_.'].",
  "lastNameLengthError": "Longueur comprise entre 1 et 50 caractères.",
  "lastNameFormatError": "Caractères spéciaux autorisés sauf en début ou fin --> [ -_.'].",
  "loginLengthError": "Longueur comprise entre 3 et 50 caractères.",
  "loginFormatError": "Minuscules uniquement. Caractères spéciaux autorisés sauf en début ou fin --> [!$%&'*+=?^`{'{'}{'|'}{'}'}~{'@'}_.-].",
  "emailFormatError": "Le format de l'email est invalide.",
  "create": {
    "title": "Ajouter un utilisateur",
    "information": "Informations",
    "saveButton": "Créer l'utilisateur",
    "confirm": {
      "title": "Création d'un utilisateur"
    }
  },
  "lastName": "Nom",
  "firstName": "Prénom",
  "addUser": {
    "button": "Nouvel utilisateur"
  },
  "login": "Login",
  "email": "Email",
  "language": "Langue",
  "profile": "Profil",
  "profilePlaceholder": "Recherche par nom du profil",
  "profileRequired": "Le profil est requis.",
  "groups": "Groupes",
  "groupsSearchPlaceholder": "Rechercher par nom du groupe",
  "sectors": "Secteurs",
  "update": {
    "title": "Modifier un utilisateur",
    "confirm": {
      "title": "Mise à jour de l’utilisateur"
    }
  },
  "confirm": {
    "message": "Confirmez-vous l’annulation de l’opération ? Toutes les données non enregistrées seront perdues."
  },
  "filters": {
    "selectionQuickFilters": {
      "allUsers": "Tous les utilisateurs",
      "selectedUsers": "Utilisateurs sélectionnés",
      "unselectedUsers": "Utilisateurs non sélectionnés"
    }
  },
  "read": {
    "title": "Voir l'utilisateur"
  }
}
